var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DocEditorTabBar" }, [
    _c("nav", { staticClass: "DocEditorTabBar_Tabs" }, [
      _c(
        "button",
        {
          staticClass: "DocEditorTabBar_WriteTab",
          class: { _active: _vm.isActiveWrite },
          on: { click: _vm.onClickWriteTab }
        },
        [_vm._v("\n      Write\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "DocEditorTabBar_PreviewTab",
          class: { _active: !_vm.isActiveWrite },
          on: { click: _vm.onClickPreviewTab }
        },
        [_vm._v("\n      Preview\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }